var _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTabdivLoc = function SvgTabdivLoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 127 181",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.742475 110.125301c-28.48969 0-51.594175-22.062709-51.594175-49.287059 0-27.22435 23.104485-49.28706 51.594175-49.28706 28.498715 0 51.593798 22.06271 51.593798 49.28706 0 27.22435-23.095083 49.28706-51.593798 49.28706zM63.742475 0C28.761582 0 0 27.098973 0 60.51564c0 47.01986 63.742475 120.80711 63.742475 120.80711s63.7515-74.262174 63.7515-120.807112C127.493975 27.098973 98.732393 0 63.742475 0",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.19762 0 0 .21415 40.259443 19.896559)",
    fill: "none",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3H241v380H3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3H241v15H3.5zM18.5 18v365M226 18v365M3.5 343H241v40H3.5zM31 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5H40v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5H49v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5H58v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5H67v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5H76v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5H85v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5H94v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 43h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 55.5h9m-9 25h9m-9-15h2.5V64h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 49,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 113h36v50H31zM31 125.5h36m-36 25h36m-27-25v25m9-25v25m9-25v25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 148h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 113h36v50H67zM67 125.5h36m-36 25h36m-27-25v25m9-25v25m9-25v25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 148h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 113h36v50h-36zM103 125.5h36m-36 25h36m-27-25v25m9-25v25m9-25v25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 148h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 113h36v50h-36zM139 125.5h36m-36 25h36m-27-25v25m9-25v25m9-25v25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 148h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 113h36v50h-36zM175 125.5h36m-36 25h36m-27-25v25m9-25v25m9-25v25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 148h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 119,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 157,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5H40v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5H49v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5H58v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5H67v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5H76v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5H85v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5H94v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 183h9v50h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 195.5h9m-9 25h9m-9-15h2.5V204h4v1.5h2.5v5h-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 189,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 227,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 253h36v50H31zM31 265.5h36m-36 25h36m-27-25v25m9-25v25m9-25v25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 288h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 253h36v50H67zM67 265.5h36m-36 25h36m-27-25v25m9-25v25m9-25v25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 288h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 253h36v50h-36zM103 265.5h36m-36 25h36m-27-25v25m9-25v25m9-25v25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 288h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 253h36v50h-36zM139 265.5h36m-36 25h36m-27-25v25m9-25v25m9-25v25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 288h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 253h36v50h-36zM175 265.5h36m-36 25h36m-27-25v25m9-25v25m9-25v25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.5,
    cy: 297,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 288h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5zm9 0h5v1h-5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 259,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 297,
    r: 2.5
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTabdivLoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TabdivLoc.fbd6d992.svg";
export { ForwardRef as ReactComponent };